import { isSuperAdmin } from '../faunadb/queries/auth'
import { useQuery } from 'react-query';

// wrap isSuperAdmin with useQuery
export const useIsSuperAdmin = (client) => {
    return useQuery(sessionStorage.getItem("access_token"), () => isSuperAdmin(client), { enabled: !!sessionStorage.getItem("access_token") });
}